import type { MfaMethod } from "@opensea/embedded-wallet-sdk"
import { cancelMfaChallenge } from "@opensea/embedded-wallet-sdk"
import { proxy, ref } from "valtio"
import { deepClone } from "valtio/utils"
import { MfaChallengeActions } from "./mfaChallengeStore"

// -- Helpers -------------------------------------------------------
const STORE_RESET_DELAY = 500

// -- Types ---------------------------------------------------------
type MfaHandlerStateType = {
  needsEnrollment: boolean
  needsAuthentication: boolean
  mfaMethods: MfaMethod[]
  onComplete: () => void
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: MfaHandlerStateType = {
  needsEnrollment: false,
  needsAuthentication: false,
  mfaMethods: [],
  onComplete: ref(() => {}),
}

export const MfaHandlerState = proxy<MfaHandlerStateType>(
  deepClone(INITIAL_STATE),
)

// -- Actions -------------------------------------------------------
export const MfaHandlerActions = {
  startMfaChallenge: (mfaMethods: MfaMethod[], onComplete: () => void) => {
    MfaHandlerState.needsEnrollment = mfaMethods.length === 0
    MfaHandlerState.needsAuthentication = mfaMethods.length !== 0
    MfaHandlerState.mfaMethods = mfaMethods
    MfaHandlerState.onComplete = ref(onComplete)
  },

  cancelMfaChallenge: async () => {
    await cancelMfaChallenge()
    MfaHandlerState.needsAuthentication = false
    MfaHandlerState.needsEnrollment = false
    setTimeout(() => {
      MfaChallengeActions.reset()
    }, STORE_RESET_DELAY)
  },

  startMfaEnrollment() {
    MfaHandlerState.needsEnrollment = true
  },

  completeEnrollment() {
    MfaHandlerState.needsEnrollment = false
    MfaHandlerState.onComplete()
  },

  completeChallenge() {
    MfaHandlerState.needsAuthentication = false
    MfaHandlerState.onComplete()
  },
}
